export default {
    ToggleDisplayLayer: 'toggle-display-layout',
    SelectDisplayBasemap: 'select-base-map'
}